import moment from "moment";

export const dateToFormat = (date, format) => {
  return moment(date).format(format);
};
